<script setup lang="ts">
import { ZendeskPartnerSupportLink } from '@/components/session/kyc/supportLinks/ZendeskPartnerSupportLink';

const props = defineProps<{
  cardholderId: string;
  partnerName: string;
  reason: string;
}>();

const supportLink = ZendeskPartnerSupportLink.forPartnerName(props.partnerName)
  .create({
    cardholderId: props.cardholderId,
    errorReason: props.reason,
  })
  .toString();
</script>

<template>
  If the issue persists, reach out to us through the
  <a :href="supportLink" target="_blank" class="underline">support center</a>.
</template>
